import React from "react";
import { selectUserRole } from "features/auth/authSlice";
import { useAppSelector } from "app/hooks";
import TodaysAbsentees from "./components/TodaysAbsentees";
import TopInstallers from "./components/statistics/TopInstallers";
import StatisticsSummary from "./components/statistics/StatisticsSummary";
import { UserRole } from "features/auth/types/user";
import { Grid2 as Grid } from "@mui/material";
import PageLayout from "components/PageLayout";
import AllBookingsList from "./components/AllBookingsList";
import { useAuthContext } from "features/auth/AuthContext";

const Dashboard: React.FC = () => {
  const { hasRole } = useAuthContext();

  return (
    <PageLayout sx={{ display: "grid", gap: 1, mt: 1 }}>
      {hasRole([UserRole.ADMIN]) && (
        <Grid container spacing={2}>
          <Grid size={{ md: 5 }} display="flex" flexDirection="column" flexGrow={1}>
            <StatisticsSummary />
          </Grid>
          <Grid size={{ md: 7 }} display="flex" flexDirection="column" flexGrow={1}>
            <TopInstallers />
          </Grid>
        </Grid>
      )}

      <TodaysAbsentees />

      {hasRole([UserRole.ADMIN, UserRole.USER_ADMIN]) && <AllBookingsList />}
    </PageLayout>
  );
};

export default Dashboard;
